<!-- rot, grün, gelb, ... Alarme anzeigen und das Ergebnis -->
<template>

  <div class="container-fluid mt-5">

    <div class="row">
      <div class="col-sm-3">

        <!-- Navigation -->
        <div class="sticky-nav">
          <b-nav vertical>
            <b-nav-item active>
              <a href="#kurzbeschreibung" @click="scrollToElement('kurzbeschreibung')">{{ $t("message.api_nav_kurzbeschreibung") }}</a>
            </b-nav-item>
            <b-nav-item>
              <a href="#versionen" @click="scrollToElement('versionen')">{{ $t("message.api_nav_versionen") }}</a>
            </b-nav-item>

            <b-nav-item>
              <a href="#auth" @click="scrollToElement('requests')">{{ $t("message.api_nav_request") }}</a>
              <b-nav-item>
                <a href="#auth" @click="scrollToElement('auth')">{{ $t("message.api_nav_auth") }}</a>
              </b-nav-item>
              <b-nav-item>
                <a href="#url" @click="scrollToElement('url')">{{ $t("message.api_nav_url") }}</a>
              </b-nav-item>
              <b-nav-item>
                <a href="#url" @click="scrollToElement('parameter')">{{ $t("message.api_nav_parameter") }}</a>
              </b-nav-item>
              <b-nav-item>
                <a href="#url" @click="scrollToElement('beispiel')">{{ $t("message.api_nav_beispiel") }}</a>
              </b-nav-item>
            </b-nav-item>

            <b-nav-item>
              <a href="#tokens" @click="scrollToElement('response')">{{ $t("message.api_nav_response") }}</a>
              <b-nav-item>
                <a href="#auth" @click="scrollToElement('result')">{{ $t("message.api_nav_result") }}</a>
              </b-nav-item>
            </b-nav-item>

            <b-nav-item v-if="showTokens">
              <a href="#tokens" @click="scrollToElement('tokens')">{{ $t("message.api_nav_tokens") }}</a>
            </b-nav-item>
          </b-nav>
        </div>

      </div>
      <div class="col-sm-9">

        <!-- Dokumentation -->
        <b-card :title="$t('message.api_title_kurzbeschreibung')" class="mt-2" id="kurzbeschreibung">
          <b-card-text>
            <p>{{ $t('message.api_desc_kurzbeschreibung_1') }}</p>
            <p>{{ $t('message.api_desc_kurzbeschreibung_2') }}</p>
          </b-card-text>
        </b-card>

        <b-card :title="$t('message.api_title_versionen')" class="mt-2" id="versionen">
          <b-card-text>
            {{ $t('message.api_desc_versionen') }}
            <ul class="mt-2">
              <li>V01 - 29.04.25</li>
            </ul>
          </b-card-text>
        </b-card>

        <b-card :title="$t('message.api_title_requests')" class="mt-2" id="requests">

          <b-card-text>
            <b-card :title="$t('message.api_title_auth')" class="mt-2" id="auth">
              <b-card-text>
                {{ $t('message.api_desc_auth_1') }}
                <span v-if="showTokens">{{ $t('message.api_desc_auth_2') }}</span>
                <span v-else>{{ $t('message.api_desc_auth_3') }}</span>
                {{ $t('message.api_desc_auth_4') }}
                <b-alert show variant="light"><code>Authentication: Bearer &lt;token&gt;</code></b-alert>
                {{ $t('message.api_desc_auth_5') }}
              </b-card-text>
            </b-card>
          </b-card-text>

          <b-card-text>
            <b-card :title="$t('message.api_title_url')" class="mt-2" id="url">
              <b-card-text>
                <p>
                  {{ $t('message.api_desc_url_1') }}
                  <b-alert show variant="light">
                    <code>{{ server_url }}/api/&lt;api-version&gt;/</code>
                  </b-alert>
                </p>
                <p>
                  {{ $t('message.api_desc_url_2') }}
                  <b-alert show variant="light">
                    <code>/api/&lt;api-version&gt;/results</code>
                  </b-alert>
                </p>
              </b-card-text>
            </b-card>
          </b-card-text>

          <b-card-text>
            <b-card :title="$t('message.api_title_parameter')" class="mt-2" id="parameter">
              <b-card-text>
                <p>
                  {{ $t('message.api_desc_parameter_1') }}
                  <b-alert show variant="light">
                    <div class="table-responsive">
                      <table class="table">
                      <thead>
                      <tr>
                        <th>{{ $t('message.api_table_header_name') }}</th>
                        <th>{{ $t('message.api_table_header_beschreibung') }}</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr>
                        <td>month</td>
                        <td>{{ $t('message.api_table_param_month') }}</td>
                      </tr>
                      <tr>
                        <td>year</td>
                        <td>{{ $t('message.api_table_param_year') }}</td>
                      </tr>
                      <tr>
                        <td>order_number</td>
                        <td>{{ $t('message.api_table_param_order_number') }}</td>
                      </tr>
                      </tbody>
                      <tfoot>
                      <tr>
                        <td colspan="2" v-html="$t('message.api_table_param_footer')">
                        </td>
                      </tr>
                      </tfoot>
                    </table>
                    </div>
                  </b-alert>
                </p>
              </b-card-text>
            </b-card>
          </b-card-text>

          <b-card-text>
            <b-card :title="$t('message.api_title_beispiel')" class="mt-2" id="beispiel">
              <b-card-text>
                <p>
                  {{ $t('message.api_desc_beispiel_1') }}
                  <b-alert show variant="light">
                    <code>
                      curl --location '{{ server_url }}/api/&lt;api-version&gt;/results?order_number=&lt;XYZ&gt;' \
                      --header 'Authorization: Bearer &lt;bearer-token&gt;'
                    </code>
                  </b-alert>
                </p>
              </b-card-text>
              <b-card-text>
                <p>
                  {{ $t('message.api_desc_beispiel_2') }}
                  <b-alert show variant="light">
                    <code>
                      curl --location '{{ server_url }}/api/&lt;api-version&gt;/results??month=&lt;XX&gt;&year=&lt;YYYY&gt;' \
                      --header 'Authorization: Bearer &lt;bearer-token&gt;'
                    </code>
                  </b-alert>
                </p>
              </b-card-text>
            </b-card>
          </b-card-text>

        </b-card>

        <!--
        Beschreibung des Ergebnisses
            {
              "task": null,
              "area": "Produktion und Lager",
              "position_no": "0005",
              "position_description": "hinter Regal",
              "article": "Schabenfalle Feuchtraum schwarz",
              "advisor": null,
              "result": null,
              "alarm_level": "GRUEN",
              "amount": null,
              "unit": null,
              "item": null,
              "is_not_checkable": null,
              "remarks": null,
              "start": null,
              "end": null,
              "timestamp": 1739364592000,
              "bioTech247_device_id": "B12CV9QI",
              "bioTech247_device_name": "0002- Müllraum links Feuerlöscher",
              "bioTech247_device_description": null,
              "bioTech247_device_status": "ACTIVE",
              "bioTech247_report_type": "NULL",
              "bioTech247_report_event_type": null,
              "bioTech247_device_installed_to": "2025-02-12T13:30:55Z",
              "bioTech247_device_installed_from": "2023-09-18T07:50:49Z",
              "bioTech247_trap": null
          },
        -->
        <b-card :title="$t('message.api_title_response')" class="mt-2" id="response">
          <b-card-text>
            {{ $t('message.api_desc_response') }}
            <b-alert show variant="light">
              <code>
                {<br>
                &nbsp;&nbsp;"results": [<br>
                &nbsp;&nbsp;&nbsp;&nbsp;{...}<br>
                &nbsp;&nbsp;]<br>
                }
              </code>
            </b-alert>
            <br>
            <h5 class="text-left" id="result">{{ $t('message.api_title_result') }}</h5>
            <div class="table-responsive">
              <table class="table">
              <thead>
              <tr>
                <th>{{ $t('message.api_table_header_name') }}</th>
                <th>{{ $t('message.api_table_header_beschreibung') }}</th>
              </tr>
              </thead>
              <tbody>
              <tr>
                <td>timestamp</td>
                <td>{{ $t('message.api_table_result_timestamp') }}</td>
              </tr>
              <tr>
                <td>area</td>
                <td>{{ $t('message.api_table_result_area') }}</td>
              </tr>
              <tr>
                <td>position_no</td>
                <td>{{ $t('message.api_table_result_position_no') }}</td>
              </tr>
              <tr>
                <td>position</td>
                <td>{{ $t('message.api_table_result_position') }}</td>
              </tr>
              <tr>
                <td>task</td>
                <td>{{ $t('message.api_table_result_task') }}</td>
              </tr>
              <tr>
                <td>indicators</td>
                <td>{{ $t('message.api_table_result_indicators') }}</td>
              </tr>
              <tr>
                <td>result</td>
                <td>{{ $t('message.api_table_result_result') }}</td>
              </tr>
              <tr>
                <td>is_not_checkable</td>
                <td>{{ $t('message.api_table_result_is_not_checkable') }}</td>
              </tr>
              <tr>
                <td>alarm_level</td>
                <td>
                  <ul>
                    <li><b>GRUEN</b>: {{ $t('message.api_table_result_alarm_gruen') }}</li>
                    <li><b>GELB</b>: {{ $t('message.api_table_result_alarm_gelb') }}</li>
                    <li><b>ROT</b>: {{ $t('message.api_table_result_alarm_rot') }}</li>
                  </ul>
                </td>
              </tr>
              <tr>
                <td>remarks</td>
                <td>{{ $t('message.api_table_result_remarks') }}</td>
              </tr>
              <tr>
                <td>item</td>
                <td>{{ $t('message.api_table_result_item') }}</td>
              </tr>
              <tr>
                <td>amount</td>
                <td>{{ $t('message.api_table_result_amount') }}</td>
              </tr>
              <tr>
                <td>unit</td>
                <td>{{ $t('message.api_table_result_unit') }}</td>
              </tr>
              <tr>
                <td>user</td>
                <td>{{ $t('message.api_table_result_user') }}</td>
              </tr>

              <tr>
                <td>bioTech247_device_id</td>
                <td>{{ $t('message.api_table_result_bioTech247_device_id') }}</td>
              </tr>
              <tr>
                <td>bioTech247_device_name</td>
                <td>{{ $t('message.api_table_result_bioTech247_device_name') }}</td>
              </tr>
              <tr>
                <td>bioTech247_device_description</td>
                <td>{{ $t('message.api_table_result_bioTech247_device_description') }}</td>
              </tr>
              <tr>
                <td>bioTech247_device_status</td>
                <td>
                  {{ $t('message.api_table_result_bioTech247_device_status') }}
                  <ul>
                    <li><b>INACTIVE:</b> {{ $t('message.api_table_result_bioTech247_device_status_inactive') }}</li>
                    <li><b>ACTIVE:</b> {{ $t('message.api_table_result_bioTech247_device_status_active') }}</li>
                    <li><b>HEARTBEAT_FAILED:</b> {{ $t('message.api_table_result_bioTech247_device_status_heartbeat') }}</li>
                    <li><b>TRIGGERED:</b> {{ $t('message.api_table_result_bioTech247_device_status_triggered') }}</li>
                    <li><b>LOW_BATTERY:</b> {{ $t('message.api_table_result_bioTech247_device_status_low_battery') }}</li>
                    <li><b>LOCATION_MODE:</b> {{ $t('message.api_table_result_bioTech247_device_status_location') }}</li>
                    <li><b>UNSTABLE_WIFI:</b> {{ $t('message.api_table_result_bioTech247_device_status_unstable') }}</li>
                    <li><b>LIGHT_INFESTATION:</b> {{ $t('message.api_table_result_bioTech247_device_status_light') }}</li>
                    <li><b>SEVERE_INFESTATION:</b> {{ $t('message.api_table_result_bioTech247_device_status_severe') }}</li>
                    <li><b>FALSE_TRIGGERED:</b> {{ $t('message.api_table_result_bioTech247_device_status_false') }}</li>
                    <li><b>ACTIVITY_WARNING:</b> {{ $t('message.api_table_result_bioTech247_device_status_warning') }}</li>
                    <li><b>ACTIVITY_CRITICAL:</b> {{ $t('message.api_table_result_bioTech247_device_status_critical') }}</li>
                    <li><b>BAIT_LOW:</b> {{ $t('message.api_table_result_bioTech247_device_status_bait_low') }}</li>
                    <li><b>ACTIVITY_CRITICAL_BAIT_LOW:</b> {{ $t('message.api_table_result_bioTech247_device_status_activity_critical_bait_low') }}</li>
                  </ul>
                </td>
              </tr>
              <tr>
                <td>bioTech247_report_type</td>
                <td>
                  {{ $t('message.api_table_result_bioTech247_report_type') }}
                  <ul>
                    <li><b>TRIGGERED:</b> {{ $t('message.api_table_result_bioTech247_report_type_triggered') }}</li>
                    <li><b>FALSE_TRIGGERED:</b> {{ $t('message.api_table_result_bioTech247_report_type_false_triggered') }}</li>
                    <li><b>INFESTED:</b> {{ $t('message.api_table_result_bioTech247_report_type_infested') }}</li>
                    <li><b>REARMED:</b> {{ $t('message.api_table_result_bioTech247_report_type_rearmed') }}</li>
                    <li><b>LIGHT_INFESTATION:</b> {{ $t('message.api_table_result_bioTech247_report_type_light') }}</li>
                    <li><b>SERVERE_INFESTATION:</b> {{ $t('message.api_table_result_bioTech247_report_type_severe') }}</li>
                    <li><b>ACTIVITY_WARNING:</b> {{ $t('message.api_table_result_bioTech247_report_type_warning') }}</li>
                    <li><b>ACTIVITY_CRITICAL:</b> {{ $t('message.api_table_result_bioTech247_report_type_critical') }}</li>
                    <li><b>CATCH_DETECTED:</b> {{ $t('message.api_table_result_bioTech247_report_type_catch') }}</li>
                    <li><b>ACTIVITY_NOTICED:</b> {{ $t('message.api_table_result_bioTech247_report_type_activity_noticed') }}</li>
                    <li><b>ACTIVITY_THRESHOLD_REACHED:</b> {{ $t('message.api_table_result_bioTech247_report_type_activity_threshold_reached') }}</li>
                    <li><b>BAIT_LOW:</b> {{ $t('message.api_table_result_bioTech247_report_type_bait_low') }}</li>
                    <li><b>ACTIVITY_THRESHOLD_REACHED_BAIT_LOW:</b> {{ $t('message.api_table_result_bioTech247_report_type_activity_threshold_reached_bait_low') }}</li>
                    <li><b>ACTIVITY_THRESHOLD_RESET:</b> {{ $t('message.api_table_result_bioTech247_report_type_activity_threshold_reset') }}</li>
                  </ul>
                </td>
              </tr>
              <tr>
                <td>bioTech247_report_event_type</td>
                <td>
                  {{ $t('message.api_table_result_bioTech247_report_event_type') }}
                  <ul>
                    <li><b>TRAP_TRIGGERED:</b> {{ $t('message.api_table_result_bioTech247_report_event_type_triggered') }}</li>
                    <li><b>CATCH_DETECTED:</b> {{ $t('message.api_table_result_bioTech247_report_event_type_catch') }}</li>
                    <li><b>REARMED:</b> {{ $t('message.api_table_result_bioTech247_report_event_type_rearmed') }}</li>
                    <li><b>OFFLINE:</b> {{ $t('message.api_table_result_bioTech247_report_event_type_offline') }}</li>
                    <li><b>ONLINE:</b> {{ $t('message.api_table_result_bioTech247_report_event_type_online') }}</li>
                    <li><b>CONFIGURED:</b> {{ $t('message.api_table_result_bioTech247_report_event_type_configured') }}</li>
                    <li><b>MAINTAINED:</b> {{ $t('message.api_table_result_bioTech247_report_event_type_maintained') }}</li>
                    <li><b>BATTERY_LOW:</b> {{ $t('message.api_table_result_bioTech247_report_event_type_battery') }}</li>
                    <li><b>IMAGE_RECEIVED:</b> {{ $t('message.api_table_result_bioTech247_report_event_type_image') }}</li>
                    <li><b>ACTIVITY_NOTICED:</b> {{ $t('message.api_table_result_bioTech247_report_event_type_activity_noticed') }}</li>
                    <li><b>ACTIVITY_THRESHOLD_REACHED:</b> {{ $t('message.api_table_result_bioTech247_report_event_type_activity_threshold_reached') }}</li>
                    <li><b>BAIT_LOW:</b> {{ $t('message.api_table_result_bioTech247_report_event_type_bait_low') }}</li>
                    <li><b>ACTIVITY_THRESHOLD_REACHED_BAIT_LOW:</b> {{ $t('message.api_table_result_bioTech247_report_event_type_activity_threshold_reached_bait_low') }}</li>
                  </ul>
                </td>
              </tr>
              <tr>
                <td>bioTech247_trap</td>
                <td>{{ $t('message.api_table_result_bioTech247_trap') }}</td>
              </tr>
              </tbody>
            </table>
            </div>

          </b-card-text>
        </b-card>

        <!-- Token der Standorte anzeigen -->
        <b-card :title="$t('message.api_token_anzeigen')" class="mt-2" id="tokens" v-if="showTokens">
          <b-card-text>
            <p>{{ $t('message.api_desc_token') }}</p>
            <b-list-group v-if="$store.getters.standorte && $store.getters.standorte.length > 0">
              <b-list-group-item v-for="(standort, index) in $store.getters.standorte" :key="standort.cardcode">
                <ShowToken v-model="$store.getters.standorte[index]" />
              </b-list-group-item>
            </b-list-group>
            <ShowToken class="mt-2" v-else-if="$store.getters.customer" v-model="$store.getters.customer" />
          </b-card-text>
        </b-card>

      </div>
    </div>

  </div>

</template>

<script>

    import ShowToken from "@/components/api/ShowToken.vue";

    export default {
      name: 'ApiDokumentation',
      components: {
        ShowToken
      },
      props: ['showTokens'],
      data: function () {
        return {
          server_url: process.env.VUE_APP_SERVER_URL,
        }
      },
      methods: {

        scrollToElement(elementId) {
          const element = document.getElementById(elementId)
          if (element) {
            element.scrollIntoView({
              behavior: 'smooth',
              block: 'start',
            })
          }
        },

      }

    }

</script>

<style scoped>

  .card-title {
    text-align: left;
  }

  .sticky-nav {
    position: sticky;
    top: 20px;
    max-height: calc(100vh - 40px);
    overflow-y: auto;
  }

</style>
